export const getUrlParam = (urlParam: string) => {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(urlParam);
  return value;
};